<template>
  <div :class="$style.container">
    <header :class="$style.header">
      <h1 :class="$style.logo">
        <router-link
          :class="$style.logoLink"
          :to="user.account_type > 30 ? '/operator/'
            : user.account_type > 20 ? '/counselor/'
            : user.account_type > 10 ? '/teacher/'
            : user.account_type ? '/'
            : ''"
            @click="deleteTabState">
          <img
            :class="$style.logoImg"
            :src="require('@/assets/images/logo.png')"
            alt="welcome to talk"
          />
        </router-link>
      </h1>

      <div
        :class="$style.nav"
        v-if="user.login.isLogin
          && !page.name.includes('Signup')">
        <div :class="`${$style.navItem} ${$style.hiddenItem}`">
          <round-img
            v-if="!user.lti"
            width="40px"
            :src="getMyIconUrl(user)" />
          <round-img-LTI
            v-else
            :src="getMyIconUrl(user)"
            :size="'xs'" />
          <!-- 旧: アイコン後 1.5 + ラベル群の間 1.5。ラベルを縦積みに集約したため同幅(3)の1本に統合 -->
          <spacer :x="3" />
          <p
            :class="$style.navItem__label"
            v-if="user.account_type > 30">{{ helper.isAccountingAccount ? '経理用' : '事務局サイト' }}</p>
          <div
            v-else-if="isSchoolAdmin"
            :class="$style.schoolAdminLabel">
            <!-- ヘッダーはサイトの看板を出す面なので schools.name(サイト表示名)を表示する。
                 name は「画面に出す名前」で、契約主体の名称は corporate_name(法人名)が持つ。
                 name は notNullable だが空文字は入りうる（必須はアプリ層の担保）ため、
                 ?? でなく || でフォールバックして空文字も未設定として扱う。 -->
            <!-- 利用者側(下の siteDisplayName)と同じ列を描画するため、同様に補間でエスケープする -->
            <p
              :class="$style.navItem__label">{{ user.school?.[0]?.name || '学校未登録' }}</p>
            <!-- 学校未所属時は customer_id が "null-<type>-<id>" になるため、school の有無でガードして非表示にする -->
            <p
              :class="$style.navItem__label">{{ schoolAdminTypeLabel }}<template v-if="user.school?.[0] && user.customer_id">：{{ user.customer_id }}</template></p>
          </div>
          <div
            v-else
            :class="$style.userLabel">
            <!-- 利用者(1〜10)は サイト表示名 を customer_id・氏名の上に縦積みで表示する。
                 未所属/school 未ロード/サイト表示名が空のときは siteDisplayName が空文字で1行目を
                 描画しないため、従来どおり customer_id + 氏名の1行に縮退する -->
            <!-- siteDisplayName は事務局が入力する組織名(schools.name)で HTML を埋める要件が無く、
                 更新 API は未認証で到達しうるため、v-html でなく補間でエスケープして描画する -->
            <p
              v-if="siteDisplayName"
              :class="$style.navItem__label">{{ siteDisplayName }}</p>
            <p :class="`${$style.navItem__label} ${$style.userLabel__row}`">
              <span v-if="user.customer_id && user.account_type <= 10">{{ user.customer_id }}</span>
              <!-- username は自由入力の氏名で HTML を埋める要件が無いため、上の siteDisplayName と
                   同様に v-html でなく補間でエスケープして描画する -->
              <span>{{ user.username }}</span>
            </p>
          </div>
        </div>
        <spacer :x="3" />
        <div :class="`${$style.navItem} ${$style.hiddenItem}`">
          <router-link
            :to="user.account_type > 30 ? '/account/'
              : user.account_type > 20 ? '/counselor/account/'
              : user.account_type > 10 ? '/teacher/school/'
              : '/settings/'"
            @click="deleteTabState">
            <round-img width="40px" src="/img/dummy/setting.png" />
          </router-link>
        </div>
        <spacer :x="3" />
        <div :class="$style.navItem">
          <button
            @click="toggleIsShownMenu"
            :class="$style.triggerDrawer"
          >
            <i class="fa-solid fa-bars" />
          </button>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RoundImg from '@/views/components/RoundImg';
import RoundImgLTI from '@/views/components/RoundImg-LTI';
import Spacer from '@/views/components/Spacer';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'GlobalHeader',
  components: {
    RoundImg,
    RoundImgLTI,
    Spacer,
  },
  mixins: [cf],
  computed: {
    ...mapState(['user', 'layout', 'page', 'helper']),
    /** 学校/企業の管理者サイト(主/副管理者)か #3185 */
    isSchoolAdmin() {
      return [11, 12].includes(this.user.account_type);
    },
    /** ヘッダー種別ラベル(学校/企業問わず統一) #3185 */
    schoolAdminTypeLabel() {
      return this.user.account_type === 11 ? '管理者' : '副管理者';
    },
    /**
     * 利用者(account_type 1〜10)ヘッダーに表示する所属組織のサイト表示名(schools.name)。
     * 管理者(11/12)は別途サイト表示名を表示済み・カウンセラー/事務局は対象外。
     * school 未ロード/未所属/サイト表示名が空のときは空文字で非表示にする
     * (user.school[0] 直参照の TypeError 回避と、空の name のフォールバックを兼ねる)。
     */
    siteDisplayName() {
      const isUser = this.user.account_type && this.user.account_type <= 10;
      return isUser ? (this.user.school?.[0]?.name ?? '') : '';
    },
  },
  methods: {
    ...mapActions('layout', [
      'toggleIsShownMenu',
    ]),
    /** LSにtab情報があれば削除 */
    deleteTabState() {
      cf.deleteTabState();
    },
  },
};
</script>

<style module lang="scss">
.container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 20px;
  // 帯の実効色。既定オレンジ／学校・企業管理者サイト(/teacher)は main.js が
  // mount 前に青へ同期上書き。account_type 非同期ロードのちらつき回避 #3185
  background-color: var(--header-band-color);
  color: #fff;
  z-index: 3;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);

  @include sm-view {
    padding: 0 16px;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--header-height);
}

.logo {
  max-width: 250px;

  @include sm-view {
    max-width: 170px;
  }
}

.nav {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.navItem {
  display: flex;
  align-items: center;

  @include sm-view {
    &.hiddenItem {
      display: none;
    }
  }
}

.navItem__label {
  font-size: 16px;
  color: #fff;
}

.schoolAdminLabel {
  // サイト表示名と種別ラベル(主/副管理者・customer_id)を縦並び(改行)にする
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.userLabel {
  // 利用者ヘッダーは サイト表示名 / customer_id + 氏名 の2段組みにする
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.userLabel__row {
  // 2行目の customer_id と氏名の間隔(&nbsp; を使わず gap で取る)
  display: flex;
  align-items: center;
  gap: 8px;
}

.triggerDrawer {
  color: #fff;
  font-size: 30px;
  background-color: transparent;
  border: none;
  appearance: none;

  @include sm-view {
    width: 30px;
  }
}

</style>
